module.exports = __webpack_public_path__ + "static/media/dpc-bg.8417a588.jpg";